import { AIInsight } from '../types';

const summaries = [
    'A steady plan beats a flashy plan. Focus on cash flow first, then optimize your asset mix.',
    'Automation and consistency beat timing the market. Small wins compound faster than big bets.',
    'Protect your downside so your upside has room to grow. Diversification is the real edge.',
    'Build optionality by trimming expenses and stacking income streams before taking on more risk.',
];

const actionItems = [
    'Review your monthly expenses and identify one recurring cut to redirect into savings.',
    'Set a portfolio income target and map the holdings needed to reach it.',
    'Rebalance contributions toward your highest-confidence long-term positions.',
    'Schedule a quarterly portfolio review to keep decisions calm and rule-based.',
];

const wealthTips = [
    '“Increase your savings rate before you increase your lifestyle.”',
    '“Make the plan boring so the results can be exciting.”',
    '“Cash flow clarity reduces stress and improves decision-making.”',
    '“A margin of safety is the best performance enhancer.”',
];

const pickRandom = (items: string[], indexSeed: number) => items[indexSeed % items.length];

export const generateBlogInsights = async (content: string, title: string): Promise<AIInsight> => {
    const seed = Math.abs(`${title}${content}`.length);
    return {
        summary: pickRandom(summaries, seed),
        actionItems: [
            pickRandom(actionItems, seed + 1),
            pickRandom(actionItems, seed + 2),
            pickRandom(actionItems, seed + 3),
        ],
        wealthTip: pickRandom(wealthTips, seed + 4),
    };
};
